import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faChevronDown, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { servicesData } from '../data/servicesData';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const menuRef = useRef(null);
  const servicesRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 0);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const onClickOutsideMenu = e => {
      if (
        isOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        !e.target.closest('.menu-icon')
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutsideMenu);
    return () => document.removeEventListener('mousedown', onClickOutsideMenu);
  }, [isOpen]);

  useEffect(() => {
    const onClickOutsideServices = e => {
      if (
        isServicesOpen &&
        servicesRef.current &&
        !servicesRef.current.contains(e.target)
      ) {
        setIsServicesOpen(false);
      }
    };
    document.addEventListener('mousedown', onClickOutsideServices);
    return () => document.removeEventListener('mousedown', onClickOutsideServices);
  }, [isServicesOpen]);

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 769px)');
    const onChange = e => {
      if (e.matches) {
        setIsOpen(false);
        setIsServicesOpen(false);
      }
    };
    mq.addEventListener('change', onChange);
    if (mq.matches) {
      setIsOpen(false);
      setIsServicesOpen(false);
    }
    return () => mq.removeEventListener('change', onChange);
  }, []);

  const handleLinkClick = path => {
    navigate(path);
    setIsOpen(false);
    setIsServicesOpen(false);
  };

  const toggleServices = () => {
    if (window.innerWidth < 769) {
      setIsServicesOpen(o => !o);
    }
  };
  

  return (
    <>
      {isOpen && <div className="backdrop" onClick={() => setIsOpen(false)} />}

      <div className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container">
          <div className="logo" onClick={() => handleLinkClick('/')}>
            <img
              className="logo-img"
              src={
                isScrolled
                  ? '/Images/ONPOINT-Logo-White.png'
                  : '/Images/ONPOINT-Logo.png'
              }
              alt="Logo"
            />
          </div>

          <div className="menu-icon" onClick={() => setIsOpen(o => !o)}>
            <FontAwesomeIcon
              icon={isOpen ? faTimes : faBars}
              className={`fa-icon ${isOpen ? 'open' : ''}`}
            />
          </div>

          <div ref={menuRef} className={`navbar-link ${isOpen ? 'active' : ''}`}>
            <div className="sidebar-logo">
              <img
                src={
                  isScrolled
                    ? '/Images/ONPOINT-Logo-White.png'
                    : '/Images/ONPOINT-Logo.png'
                }
                alt="Logo"
              />
            </div>
            <div className="hr" />

            <div className="link" onClick={() => handleLinkClick('/')}>
              Home
            </div>
            <div className="link" onClick={() => handleLinkClick('/aboutus')}>
              About Us
            </div>

            <div
              ref={servicesRef}
              className={`link services ${isServicesOpen ? 'open' : ''}`}
              onClick={toggleServices}
            >
              Services
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`chevron ${isServicesOpen ? 'open' : ''}`}
              />
              <ul className={`dropdown ${isServicesOpen ? 'open' : ''}`}>
                {servicesData.map(s => (
                  <li
                    key={s.id}
                    className='poppins-medium'
                    onClick={() =>
                      handleLinkClick(`/services/${s.id}`)
                    }
                  >
                    {s.title}
                  </li>
                ))}

              </ul>
            </div>

            <div
              className="link contact"
              onClick={() => handleLinkClick('/contactus')}
            >
              Contact Us
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
